/* COMPONENTS */
import { Button, Grid } from "@material-ui/core";
import { useEffect, useState } from "react";
import { dbGet } from "utils/DBFetchers";

import LoaderBar from "components/LoaderBar/LoaderBar";
import CustomMUIDataTable from "components/MUIDatatable/CustomMUIDataTable";
import PageTitle from "components/PageTitle/PageTitle";

export default function DeveloperPharmaciesPage() {
    const [newFormattedTableData, setNewFormattedTableData] = useState([]);
    const [dynamicColumns, setDynamicColumns] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [downloadLink, setDownloadLink] = useState("")

    const getPharmacies = () => {
        setIsLoading(true);
        dbGet("/pharmacies/developer")
            .then((response) => {
                const responseData = response.data;

                if (responseData && responseData.formatted_data && responseData.formatted_data.length > 0) {
                    const dataRows = responseData.formatted_data;
                    const columnsOrder = responseData.columns_order;

                    const generatedColumns = columnsOrder.map((colName) => ({
                        name: colName,
                        label: colName,
                        options: { filter: true, sort: true }
                    }));

                    setDynamicColumns(generatedColumns);
                    setNewFormattedTableData(dataRows);
                    setDownloadLink(responseData.download_link)
                } else {
                    setDynamicColumns([]);
                    setNewFormattedTableData([]);
                }
            })
            .catch((error) => {
                // console.error("Error obteniendo farmacias:", error);
                setDynamicColumns([]);
                setNewFormattedTableData([]);
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    useEffect(() => {
        getPharmacies();
    }, []);

    const onDownload = () => {
        // const mocked_url = "https://cfr-test-env.s3.sa-east-1.amazonaws.com/test_files/mocked_pharmacies.xlsx";
        window.open(downloadLink, "_blank");
    };

    return (
        <>
            <div>
                <PageTitle title="Farmacias Habilitadas" />
            </div>
            {isLoading ? (
                <LoaderBar />
            ) : dynamicColumns.length > 0 ? (
                <CustomMUIDataTable
                    title="Farmacias"
                    data={newFormattedTableData}
                    columns={dynamicColumns}
                    customDownloadCallback={onDownload}
                    hideFilter
                />
            ) : (
                <div style={{ padding: 20 }}>No hay farmacias asociadas al desarrollador.</div>
            )}
        </>
    );
}